export default IconGraphOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-graph-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405" />
  <path d="M7 14l3 -3l2 2l.5 -.5m2 -2l.5 -.5l2 2" />
  <path d="M3 3l18 18" />
</svg>`;